import Vue from 'vue'
import Vuex from 'vuex'
const fb = require('./firebaseConfig.js')

Vue.use(Vuex)

// handle page reload
fb.auth.onAuthStateChanged(user => {
    if (user) {
        store.commit('setCurrentUser', user)
        store.dispatch('fetchUserProfile')

        fb.usersCollection.doc(user.uid).onSnapshot(doc => {
            if (doc.exists) {
                store.dispatch('fetchUserProfile')
                store.commit('setUserProfile', doc.data())
                store.dispatch('fetchBoxes')
                store.dispatch('fetchUserBoxes')
            }
        })

    }
    else {
        store.dispatch('fetchBoxes')
    }
})

export const store = new Vuex.Store({
    state: {
        currentUser: null,
        userProfile: {},
        boxes: [],
        userBoxes: [],
    },
    actions: {
        clearData({ commit }) {
            commit('setCurrentUser', null)
            commit('setUserProfile', {})            
            commit('setBoxes', null)
            commit('setUserBoxes', null)
        },
        fetchUserProfile({ commit, state }) {            
            fb.usersCollection.doc(state.currentUser.uid).get().then(res => {
                if (res.exists) {
                    commit('setUserProfile', res.data())
                }                
            }).catch(err => {
                console.log(err)
            })
        },
        fetchUserBoxes({ commit, state }) {

            fb.boxesCollection.where("environment", "==", process.env.BOX_ENV).where("userId", "==", state.currentUser.uid).where('state', 'in', ['new','active','draft']).orderBy('createdOn', 'desc')
            .onSnapshot(querySnapshot => {

                let userBoxes = []
                querySnapshot.forEach(doc => {
                    
                    let box = doc.data()
                    box.id = doc.id
                    userBoxes.push(box)
                })

                commit('setUserBoxes', userBoxes)            

            });
        },
        fetchBoxes({ commit, state }) {

            let states = ['active', 'new']
                        fb.boxesCollection.where("environment", "==", process.env.BOX_ENV).where('state', 'in', states).orderBy('createdOn', 'desc')
            .onSnapshot(querySnapshot => {
                            
                let boxes = []
                let userBoxes = []
                querySnapshot.forEach(doc => {
                    let box = doc.data()
                    box.id = doc.id
                    boxes.push(box)
                    if (store.state.currentUser && box.userId == store.state.currentUser.uid) {
                        userBoxes.push(box)
                    }
                })

                commit('setBoxes', boxes)
                commit('setUserBoxes', userBoxes)

            });
        },
        updateProfile({ commit, state }, data) {
            let name = data.name
            let email = data.email
            let description = data.description ? data.description : null
            let contact = data.contact ? data.contact : null
            let contactEmail = data.contactEmail ? data.contactEmail : null
            let phone = data.phone ? data.phone : null
            let web = data.web ? data.web : null
            let city = data.city ? data.city : null
            let territorial = data.territorial ? data.territorial : null

            // let whatsapp = data.whatsapp ? data.whatsapp : null
            // let instagram = data.instagram ? data.instagram : null
            // let twitter = data.twitter ? data.twitter : null
            // let facebook = data.facebook ? data.facebook : null
            

            fb.usersCollection.doc(state.currentUser.uid).update({ name, email, description, contact, contactEmail, phone, web, city, territorial }).then(user => {
                // update all posts by user to reflect new name
                fb.boxesCollection.where('userId', '==', state.currentUser.uid).get().then(docs => {
                    docs.forEach(doc => {

                        fb.boxesCollection.doc(doc.id).update({
                            user: {
                                name: name,
                                email: email,
                                city: city
                            }                            
                        })
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    },
    mutations: {
        setCurrentUser(state, val) {
            state.currentUser = val
        },
        setUserProfile(state, val) {
            state.userProfile = val
        },
        setBoxes(state, val) {
            if (val) {
                state.boxes = val
            } else {
                state.boxes = []
            }
        },
        setUserBoxes(state, val) {
            if (val) {
                state.userBoxes = val
            } else {
                state.userBoxes = []
            }
        },
    }
})



// WEBPACK FOOTER //
// ./src/store.js